module.exports = __webpack_public_path__ + "static/media/instagramm.6874f794.png";